var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cont_firfin",style:(_vm.cssProps),attrs:{"id":"firfinContent"}},[_c('div',{attrs:{"id":"mArticle"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }